import orderUtils from 'utils/Order';
import checkoutUtils from 'utils/Checkout';
import skuHelpers from 'utils/skuHelpers';
import { PAYMENT_TYPES } from 'constants/RwdBasket';
import Venmo from 'utils/Venmo';

function paymentMethodCondition(isNewUserFlow) {
    return !isNewUserFlow || checkoutUtils.isGuestOrder();
}

function getAvailablePaymentMethods(orderDetails, isNewUserFlow, klarnaError) {
    const isKlarnaEnabledForThisOrder = orderUtils.isKlarnaEnabledForThisOrder(orderDetails) && !klarnaError && paymentMethodCondition(isNewUserFlow);
    const isAfterpayEnabledForThisOrder = orderUtils.isAfterpayEnabledForThisOrder(orderDetails) && paymentMethodCondition(isNewUserFlow);
    const isPazeEnabledForThisOrder = orderUtils.isPazeEnabledForThisOrder(orderDetails) && paymentMethodCondition(isNewUserFlow);
    const isVenmoEnabledForThisOrder = orderUtils.isVenmoEnabledForThisOrder(orderDetails) && paymentMethodCondition(isNewUserFlow);
    const isAfterpayEnabledForThisProfile = checkoutUtils.isAfterpayEnabledForThisProfile(orderDetails);
    const isPayPalEnabled = orderUtils.isPayPalEnabled(orderDetails);
    const isPayPalPayLaterEligible = Sephora.configurationSettings.isPayPalEnabled && orderDetails?.items?.isPayPalPayLaterEligible;

    return {
        isAfterpayEnabledForThisOrder,
        isAfterpayEnabledForThisProfile,
        isPayPalEnabled,
        isPayPalPayLaterEligible,
        isKlarnaEnabledForThisOrder,
        isPazeEnabledForThisOrder,
        isVenmoEnabledForThisOrder
    };
}

function getGiftCardPaymentGroup(paymentGroups) {
    return (paymentGroups?.paymentGroupsEntries || []).filter(group => group.paymentGroupType === orderUtils.PAYMENT_GROUP_TYPE.GIFT_CARD);
}

function checkIfAlternateMethodSelected(afterpay, klarna, paze, venmo) {
    return afterpay.isSelected || klarna.isSelected || paze.isSelected || venmo.isSelected;
}

function getAlternatePaymentName(afterpay, klarna, venmo, paze, isNewUserFlow) {
    let alternatePaymentName = '';

    if (afterpay.isSelected) {
        alternatePaymentName = PAYMENT_TYPES.PAY_AFTERPAY;
    } else if (klarna.isSelected) {
        alternatePaymentName = PAYMENT_TYPES.PAY_KLARNA;
    } else if (venmo.isSelected || (isNewUserFlow && Venmo.isVenmoExpressFlow())) {
        alternatePaymentName = PAYMENT_TYPES.PAY_VENMO;
    } else if (paze.isSelected) {
        alternatePaymentName = PAYMENT_TYPES.PAY_PAZE;
    }

    return alternatePaymentName;
}

function getInstallment(orderDetails) {
    const amount = orderDetails.priceInfo?.creditCardAmount || orderDetails.priceInfo.paypalAmount;
    const [installmentValue] = skuHelpers.formatInstallmentValue(amount);

    return installmentValue;
}

function checkGiftCardAmountEqualsOrderTotal(priceInfo) {
    return priceInfo?.giftCardAmount && priceInfo?.giftCardAmount === priceInfo?.orderTotal;
}

function checkIsAltenateMethodDefaultPayment(alternatePaymentName, defaultPayment) {
    return (
        (alternatePaymentName === PAYMENT_TYPES.PAY_AFTERPAY && defaultPayment === 'afterpay') ||
        (alternatePaymentName === PAYMENT_TYPES.PAY_KLARNA && defaultPayment === 'klarna') ||
        (alternatePaymentName === PAYMENT_TYPES.PAY_VENMO && defaultPayment === 'venmo')
    );
}

function isAnyPaymentOptionSelected(paymentGroups) {
    if (
        paymentGroups?.paymentGroupsEntries?.length === 1 &&
        paymentGroups?.paymentGroupsEntries?.[0].paymentGroupType === orderUtils.PAYMENT_GROUP_TYPE.CREDIT_CARD &&
        paymentGroups?.paymentGroupsEntries?.[0]?.paymentGroup?.message &&
        paymentGroups?.paymentGroupsEntries?.[0]?.paymentGroup?.cardNumber.length === 0
    ) {
        return false;
    }

    return true;
}

export default {
    getAvailablePaymentMethods,
    getGiftCardPaymentGroup,
    checkIfAlternateMethodSelected,
    getAlternatePaymentName,
    getInstallment,
    checkGiftCardAmountEqualsOrderTotal,
    checkIsAltenateMethodDefaultPayment,
    isAnyPaymentOptionSelected
};
